<template>
   <div
      class="bg-red absolute -right-[5px] -top-[5px] size-[14px] rounded-full border-2 border-white"
   />
</template>

<script setup lang="ts"></script>
